export function saveUser(data) {
  return {
    type: 'SAVE_USER',
    data,
  };
}

export function saveStore(data) {
  return {
    type: 'SAVE_STORE',
    data,
  };
}

export function resetState() {
  return {
    type: 'RESET',
  };
}
